
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bei der Atmung gelangt die Luft durch den Mund und die Nase in den Rachen. Solange sie ungehindert durchströmen kann, geschieht das geräuschlos. Während wir schlafen, erschlaffen jedoch die Muskeln. Danach sind die Rachenwände nicht mehr stabil, und es kann zu Vibrationen des Rachengewebes und der Atemluft kommen, wodurch das Schnarchgeräusch entsteht. Verschiedene Faktoren können das Schnarchen begünstigen: anatomische Besonderheiten wie grosse Mandeln, ein enger Rachen, ein kleiner Unterkiefer, eine verstopfte Nase bei einer Erkältung oder Heuschnupfen. Vor allem Menschen mit Übergewicht, ältere Leute, Schlafmittelkonsumenten und Raucherinnen und Raucher neigen zum Schnarchen.`}<br /><br />{`
Auch Alkohol ist ein wesentlicher Faktor. Er lässt einen zwar schneller einschlafen, dafür wacht man später öfter auf. Der Genuss von Wein oder Bier führt nicht nur zu einer Entspannung der Psyche, sondern wirkt sich auch auf die Muskulatur des Körpers aus. Nicht nur die Beine und die Augen werden schwerer, auch die Muskeln tief im Rachen am Zungengrund oder am Gaumensegel lockern sich. Und hier zeigt sich das Problem: Was entspannt ist, kann gut im Luftstrom vibrieren. Sprich: je lockerer die Muskeln im Rachen, desto geräuschvoller das Schnarchen. `}<M mdxType="M">{`Das ist so ausgeprägt, dass im alkoholisierten Zustand fast jeder schnarcht!`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;